import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './SignUp.css';

const SignUp = () => {
  const [email, setEmail] = useState('');

  return (
    <div className="signup-page">
      <div className="signup-container">
        <div className="signup-card">
          <div className="signup-header">
            <div className="logo-section">
              <div className="logo-icon">
                <img src={require('../assets/logo.png')} alt="Mobius Engine" className="logo-image" />
                <span className="logo-text">Mobius Engine</span>
              </div>
            </div>
            <h1 className="signup-title">Create Your Account</h1>
            <div className="terms-text">
              <p>By signing up, you agree to</p>
              <p>
                <a href="https://personal.ai/terms-of-service" target="_blank" rel="noopener noreferrer">
                  https://personal.ai/terms-of-service
                </a> and <a href="https://personal.ai/privacy-notice" target="_blank" rel="noopener noreferrer">
                  privacy notice https://personal.ai/privacy-notice
                </a>
              </p>
            </div>
          </div>

          <div className="signup-form">
            <div className="email-input-container">
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input"
              />
            </div>

            <button className="continue-btn">Continue</button>

            <div className="login-link">
              <span>Already have an account? </span>
              <Link to="/login" className="login-link-text">Log in</Link>
            </div>

            <div className="divider">
              <span>OR</span>
            </div>

            <div className="social-login">
              <button className="social-btn google-btn">
                <div className="social-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18">
                    <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                    <path fill="#34A853" d="M8.98 16c2.16 0 3.97-.72 5.3-1.94l-2.6-2.04a4.8 4.8 0 0 1-7.18-2.53H1.83v2.07A8 8 0 0 0 8.98 16z"/>
                    <path fill="#FBBC05" d="M4.5 9.49a4.8 4.8 0 0 1 0-3.07V4.35H1.83a8 8 0 0 0 0 7.22l2.67-2.08z"/>
                    <path fill="#EA4335" d="M8.98 3.2c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 4.35L4.5 6.42a4.8 4.8 0 0 1 4.48-3.22z"/>
                  </svg>
                </div>
                <span>Continue with Google</span>
              </button>

              <button className="social-btn microsoft-btn">
                <div className="social-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18">
                    <path fill="#f25022" d="M0 0h8.5v8.5H0z"/>
                    <path fill="#00a4ef" d="M9.5 0H18v8.5H9.5z"/>
                    <path fill="#7fba00" d="M0 9.5h8.5V18H0z"/>
                    <path fill="#ffb900" d="M9.5 9.5H18V18H9.5z"/>
                  </svg>
                </div>
                <span>Continue with Microsoft Account</span>
              </button>

              <button className="social-btn linkedin-btn">
                <div className="social-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#0077B5">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </div>
                <span>Continue with LinkedIn</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
